import { defineMessages } from '@transcend-io/internationalization';

export const communicationsPreferencesMessages = defineMessages(
  'privacy-center.pages.CommunicationsPreferences.communicationsPreferences',
  {
    intro: {
      defaultMessage: 'Manage Your Preferences',
      description:
        'The title text displayed on "Communications Preferences" page.',
    },
    loggedOutMessage: {
      defaultMessage:
        'Let us know the topics you are interested in and how you want to be contacted. ' +
        'In order to make any changes below, you have to first verify your identity or sign in.',
      description:
        'The title description text displayed for unauthenticated users on the ' +
        '"Communications Preferences" page.',
    },
    unsubscribeAll: {
      defaultMessage: 'Unsubscribe from all communications',
      description:
        'The button text to unsubscribe from all preferences on the "Communications Preferences" page.',
    },
    subscribeAll: {
      defaultMessage: 'Subscribe to all communications',
      description:
        'The button text to subscribe to all preferences on the "Communications Preferences" page.',
    },
    loggedInMessage: {
      defaultMessage:
        'Let us know the topics you are interested in and how you want to be contacted.',
      description:
        'The description text displayed for authenticated users on the ' +
        '"Communications Preferences" page.',
    },
    updatePreferences: {
      defaultMessage: 'Save Changes',
      description:
        'The button text to update preferences on the "Communications Preferences" page.',
    },
    success: {
      defaultMessage: 'Successfully updated your preferences',
      description:
        'The text displayed when preferences are updated on the "Communications Preferences" page.',
    },
    emailTitle: {
      defaultMessage: 'Email Address',
      description:
        'The title displayed next to the email address input on the "Communications Preferences" page.',
    },
    resetPreferences: {
      defaultMessage: 'Reset changes',
      description:
        'The button text to reset preferences on the "Communications Preferences" page.',
    },
    logOut: {
      defaultMessage: 'Not you?',
      description:
        'The hyperlink text to log out from the "Communications Preferences" page.',
    },
    signIn: {
      defaultMessage: 'Sign in to manage your preferences',
      description:
        'The button text to sign-in on the "Communications Preferences" page.',
    },
    goToParentPrivacyCenter: {
      defaultMessage: 'Manage preferences for related brands',
      description:
        'The button text to show on the "Communication Preferences" page ' +
        'that redirects the user to the parent Privacy Center.',
    },
    unconfirmedChanges: {
      defaultMessage:
        'You have unsaved changes. Are you sure you want to leave?',
      description:
        'The confirmation message when user tries to leave the "Communications Preferences" page with unsaved changes.',
    },
    selectPartitions: {
      defaultMessage:
        'Make the following selections that apply to you in order to ' +
        'view the relevant communication preferences that can be personally configured.',
      description:
        'The description text displayed as part of "Global Settings" ' +
        'section on "Communications Preferences" page.',
    },
    failedToLoadPurposes: {
      defaultMessage: 'Failed to load preferences!',
    },
  },
);
